module.exports = __webpack_public_path__ + "static/media/13.fd74e9fc.jpg";